import React from 'react';
import ShareGauge from './ShareGauge';

// Peças: linha única — nome | 3 métricas | margem (mini-donut) | share (mini-donut).
const PartsSection = ({ title, subtitle, color, iconGradient, icon, metrics = [], margem, share, loading }) => (
  <section className="dg-card dg-sector">
    <div className="dg-parts-layout">
      <div className="dg-sector-name dg-parts-name">
        <span className="dg-sector-icon" style={{ background: iconGradient }}>{icon}</span>
        <div>
          <div className="dg-sector-title">
            <span className="dg-sector-dot" style={{ background: color }} />
            {title}
          </div>
          <div className="dg-sector-subtitle">{subtitle}</div>
        </div>
      </div>

      <div className="dg-parts-metrics">
        {metrics.map((m) => (
          <div className="dg-parts-metric" key={m.label}>
            <div className="dg-sector-metric-value" style={m.color ? { color: m.color } : undefined}>
              {loading ? '—' : m.value}
            </div>
            <div className="dg-sector-metric-label">{m.label}</div>
          </div>
        ))}
      </div>

      <div className="dg-margin-box">
        <div className="dg-margin-title">Margem peças</div>
        <ShareGauge percent={margem} color={color} loading={loading} label="Margem" />
      </div>

      <div className="dg-share">
        <ShareGauge percent={share.percent} color={color} loading={loading} label="Share" />
        <div className="dg-share-text">
          <div className="dg-share-label">Share no faturamento total</div>
          <div className="dg-share-value">{share.sub}</div>
        </div>
      </div>
    </div>
  </section>
);

export default PartsSection;
